import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Footer.css";
import {
  FaFacebookF,
  FaYoutube,
  FaWhatsapp,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { Link } from "react-router-dom";

const Footer = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    const checkScrollTop = () => setShowScroll(window.scrollY > 300);
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-dark text-light pt-5 pb-4 mt-auto">
      <div className="container">
        <div className="row gy-4">
          
          {/* Logo */}
          <div className="col-12 col-md-6 col-lg-3">
            <a href="/" className="d-inline-block mb-3">
              <img
                src={require("../../assest/image/BR White Logo.png")}
                alt="Aalan Techsoft"
                height="60"
              />
            </a>
            <p className="small mb-4" style={{ fontSize: "16px" }}>
              Empowering careers and innovation through next-gen software learning.
            </p>
            <div className="d-flex gap-3">
              <a href="https://www.facebook.com/aalaninfo/" target="_blank" rel="noopener noreferrer" style={{ color: "#85bf39" }}>
                <FaFacebookF size={18} />
              </a>
              <a href="https://www.youtube.com/channel/UCrhSZRWj7YekwK-OP_KBpdA" target="_blank" rel="noopener noreferrer" style={{ color: "#85bf39" }}>
                <FaYoutube size={18} />
              </a>
              <a href="https://wa.me/919080108634" target="_blank" rel="noopener noreferrer" style={{ color: "#85bf39" }}>
                <FaWhatsapp size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="col-12 col-md-6 col-lg-2">
            <h5 className="fw-bold mb-3">Quick Links</h5>
            <ul className="list-unstyled small">
              {[
                ["Home", "/"],
                ["About Us", "/about-us"],
                ["Courses", "/courses"],
                ["Services", "/services"],
                ["Portfolio", "/portfolio"],
                ["Internship", "/internship"],
                ["Career", "/career"],
                ["Blogs", "/blogs"],
                ["Contact Us", "/contactus"],
              ].map(([text, link], i) => (
                <li key={i} className="mb-2">
                  <Link to={link} className="text-decoration-none link">
                    {text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Courses */}
          <div className="col-12 col-md-6 col-lg-2">
            <h5 className="fw-bold mb-3">Courses</h5>
            <ul className="list-unstyled small text-white">
              {[
                ["Python Full Stack", "/courses/python-full-stack"],
                ["Java Full Stack", "/courses/java-full-stack"],
                ["MERN Stack", "/courses/mern-stack"],
                ["MEAN Stack", "/courses/mean-stack"],
                ["Mobile App", "/courses/mobile-app-development"],
                ["Data Analysis", "/courses/data-analysis"],
                ["UI/UX Designing", "/courses/ui-ux-design"],
                ["AWS Cloud", "/courses/aws-cloud"],
                ["DevOps Engineer", "/courses/devops"],
              ].map(([text, link], i) => (
                <li key={i} className="mb-2">
                  <Link to={link} className="text-decoration-none link">
                    {text}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div className="col-12 col-md-6 col-lg-2">
            <h5 className="fw-bold mb-3">Our Services</h5>
            <ul className="list-unstyled small">
              {[
                "Web Development",
                "Mobile App Development",
                "E-Commerce",
                "ERP Software",
                "CRM Service",
                "Custom Softwares",
              ].map((service, i) => (
                <li key={i} className="mb-2">
                  <a href="/services" className="text-decoration-none link">
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-12 col-md-6 col-lg-3">
            <h5 className="fw-bold mb-3">Contact Us</h5>

            <p className="small d-flex align-items-center mb-2">
              <FaPhoneAlt size={16} className="me-2" style={{ color: "#85bf39" }} />
              <a href="tel:+919080108634" className="text-decoration-none link">
                (+91) 9080108634
              </a>
            </p>

            <p className="small d-flex align-items-center mb-2">
              <IoLogoWhatsapp size={17} className="me-2" style={{ color: "#85bf39" }} />
              <a href="https://wa.me/919789393566" target="_blank" rel="noopener noreferrer" className="text-decoration-none link">
                (+91) 9789393566
              </a>
            </p>

            <p className="small d-flex align-items-center mb-2">
              <FaEnvelope size={16} className="me-2" style={{ color: "#85bf39" }} />
              <a href="mailto:Support@aalantechsoft.com" className="text-decoration-none link">
                Support@aalantechsoft.com
              </a>
            </p>

            <p className="small d-flex align-items-start">
              <FaMapMarkerAlt size={16} className="me-2" style={{ color: "#85bf39" }} />
              J.H TOWERS - 24, <br /> LIC Colony Road, Salem-4.
            </p>
          </div>
        </div>

        <div className="text-center mt-4">
          <hr className="mb-3" />
          <p className="small mb-0">
            &copy; {new Date().getFullYear()} All Rights Reserved by Aalan Techsoft.
          </p>
        </div>
      </div>

      {/* Floating WhatsApp Button WITH HOVER BADGE */}
      <a
        href="https://wa.me/919789393566"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-floating-wrapper"
      >
        <span className="whatsapp-badge">WhatsApp Us</span>
        <div className="whatsapp-button">
          <FaWhatsapp size={28} />
        </div>
      </a>

      {/* Scroll To Top */}
      {showScroll && (
        <button
          onClick={scrollToTop}
          className="position-fixed bottom-0 end-0"
          style={{
            marginRight: "1.2rem",
            marginBottom: "25px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            backgroundColor: "#85bf39",
            border: "none",
            color: "white",
            fontSize: "24px",
            boxShadow: "0 4px 8px rgba(133,191,57,0.4)",
            cursor: "pointer",
            transition: "0.3s",
            zIndex: 1000,
          }}
        >
          ↑
        </button>
      )}
    </footer>
  );
};

export default Footer;
